/* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Modal, Button, Grid, Row, Col } from 'rsuite';

import loginService from '../services/login';
import statuses from '../constants/users/statuses';
import allRoles from '../constants/roles/roles';
import { Field } from '../helpers/rsuite/Form';
import { FormChangePassword } from './FormChangePassword.js';
import { getStoreByStorage } from '../helpers';
import { cuotitasStoreService } from '../services';
import React, { useEffect, useState } from 'react';

const disableInput = {
    backgroundColor: '#f7f9fa',
    border: '2px #c6cfd7 solid'
};

const ID_CUOTITAS_PLATFORM = 5;

function UserProfile ({ user }) {
    const [state, setState] = useState({
        usuario: user,
        query: new URLSearchParams(window.location.search),
        token: window.location.pathname.slice(7),
        showPerfil: false,
        showNewEmail: false,
        showNewPassword: false,
        username: user?.key || '',
        email: user.person.email?.description || '',
        role: false,
        newEmail: '',
    });

    const status = user?.status?.description;
    const userName = user?.person.attributes?.first_name.value || '';
    const formattedName = user?.formattedName;

    async function onInit () {
        const store = getStoreByStorage() || await getStore();
        const comercio = store?.name;
        setCommerce(comercio);
        getRole();
    }

    function getStore () {
        return cuotitasStoreService
            .getStores()
            .then((res) => {
                return res[0];
            });
    }

    function setCommerce (commerce) {
        setState((state) => ({ ...state, comercio: commerce }));
    }

    function getRole () {
        for (const role of user?.roles) {
            if (role.role.id === allRoles['admin.digital-origination']) {
                setState((state) => ({ ...state, role: 'Admin' }));
                // setState((state) => ({ ...state, role: { ...role.role, value: 'Admin' } }));
                break;
            }
            if (role.role.id === allRoles['seller.digital-origination']) {
                setState((state) => ({ ...state, role: 'Vendedor' }));
                // setState((state) => ({ ...state, role: { ...role.role, value: 'Vendedor' } }));
                break;
            }
        }
    }

    function changeEmail () {
        // POST / auth / verify
        // send an email with token and id
        const body = {
            idPlatform: ID_CUOTITAS_PLATFORM,
            email: state.email, // new email to change
            metadata: {
                user: {
                    id: state.usuario.id,
                    fullname: state.usuario.formattedName
                },
                subject: 'Verificación de nuevo email',
                url: 'http://localhost:3000/users' // TODO verify again
            }
        };

        loginService
            .changeEmail(body)
            .then(response => {
                localStorage.setItem('newEmail', state.email);
                openModalPerfil();
                alert('success', '¡Listo! Ya te enviamos un mensaje a tu casilla de email para validar el cambio.');
            })
            .catch(e => {
                alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.');
                console.error(e);
            });
    };

    function openModalPerfil () {
        setState((state) => ({ ...state, showPerfil: true, showNewEmail: false, showNewPassword: false }));
    }

    function openModalChangePassword () {
        setState((state) => ({ ...state, showPerfil: false, showNewPassword: true, showNewEmail: false }));
    }

    function close () {
        setState((state) => ({ ...state, showPerfil: false, showNewEmail: false, showNewPassword: false }));
    }

    function setNewEmail (newEmail) {
        setState((state) => ({ ...state, newEmail }));
    }

    useEffect(() => {
        onInit().catch(console.error);
    }, []);

    return (
        <div>
            <Button
                className="button-header"
                appearance='subtle'
                onClick={openModalPerfil}
            >
                Hola,<b>{` ${formattedName}`}</b>
            </Button>
            <Modal open={state.showPerfil} onClose={close}>
                <Modal.Body>
                    <div className='row m-0'>
                        <div className='col-6 p-0'>
                            <div className='d-flex justify-content-center align-items-center border rounded-lg' style={{ height: '100px', width: '100px', backgroundColor: '#e0f5ff' }} >
                                <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success" style={{ fontSize: '3rem' }}>{userName.substring(0, 1)}</span>
                            </div>
                            <h4 className='py-4 font-weight-bold m-0'>{formattedName}</h4>
                            <span className="label label-light-success label-pill label-inline" style={{ fontSize: '1rem' }}>
                                {statuses[status].text || ''}
                            </span>
                        </div>
                        <div className='col-6 p-0 w-100' >
                            <Form
                                fluid
                                // formValue={state.formUser}
                                formValue={state}
                            >
                                {/* si está validado por RENAPER es de solo lectura */}
                                {/* <Field classNameGroup = 'mb-3' classNameLabel='font-weight-bold' name="document" label="DNI" style={disableInput} readOnly/> */}
                                <Field classNameGroup = 'mb-3' classNameLabel='font-weight-bold' name="username" label="Usuario" style={disableInput} readOnly/>
                                <Field classNameGroup = 'mb-3' classNameLabel='font-weight-bold' name="role" label="Rol" style={disableInput} readOnly/>
                                <Field classNameGroup = 'mb-3' classNameLabel='font-weight-bold' name="comercio" label="Comercio" style={disableInput} readOnly/>
                            </Form>
                        </div>
                    </div>
                    <Grid fluid>
                        <Row className="show-grid text-color-primary" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <Col xs={1}>
                                <i className="fas fa-unlock-alt text-color-primary"/>
                            </Col>
                            <Col xs={8}>
                                <span onClick={openModalChangePassword} className='h6'>
                                    Cambiar contraseña
                                </span>
                            </Col>
                        </Row>
                    </Grid>

                </Modal.Body>
                <Modal.Footer>
                    <div className=" d-flex justify-content-start">
                        <Link
                            to="/logout"
                            className="rs-btn rs-btn-primary"
                            style={{ fontSize: '1.25rem', padding: '6px 32px' }}
                        >
                                Cerrar sesión
                        </Link>
                    </div>
                </Modal.Footer>
            </Modal>
            {/*  Segundo modal de cambio de email */}
            <Modal show={state.showNewEmail} onHide={close} >
                <Modal.Header>
                    <Modal.Title>Cambio de email</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ paddingBottom: '280px' }}>
                    <Form fluid>
                        <Form.Group >
                            <Form.ControlLabel className='font-weight-bold'>Nuevo email</Form.ControlLabel>
                            <Form.Control
                                name={'email'}
                                className='w-100'
                                value={state.newEmail}
                                onChange={setNewEmail}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={openModalPerfil} appearance="subtle">
                            Volver
                    </Button>
                    <Button onClick={changeEmail} appearance="primary">
                            Validar
                    </Button>
                </Modal.Footer>
            </Modal>
            {/*  Tercer modal de cambio de contraseña */}
            <Modal open={state.showNewPassword} onClose={close}>
                <Modal.Header>
                    <Modal.Title>Cambio de contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.ControlLabel className='font-weight-bold'>¿Está seguro que quiere cambiar de contraseña?</Form.ControlLabel>
                    <div >
                        <FormChangePassword/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={openModalPerfil} appearance="subtle">
                            Volver
                    </Button>

                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default connect(({ auth: { user } }) => ({ user }))(UserProfile);
